import { type PropsWithChildren } from 'react';

import type { ThresholdData } from '../../core/types/thresholds.js';

/**
 * Props for the TimeseriesChart.Threshold slot component
 * @public
 */
export interface CategoricalBarChartThresholdProps {
  /** The threshold data to be graphed by the component */
  data: ThresholdData;
  /** The unique color picked in HEX, RGB, Color Token or HSL.*/
  color: string;
  /** Whereas to show the ranges filled or only the strokes */
  strokeOnly?: boolean;
  /**
   * Label to be shown in the threshold tooltip.
   * @defaultValue "Threshold"
   */
  label?: string;
}

/**
 * @internal
 */
export const Threshold = (
  props: PropsWithChildren<CategoricalBarChartThresholdProps>,
) => null;

Threshold['displayName'] = 'CategoricalBarChart.Threshold';
